import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function ProjectleadersReducer(state = initialState.projectleaders, action: any) {
  switch (action.type) {
    case types.SAVE_PROJECTLEADERS_SUCCESS:
      return action.projectleaders;
    default:
      return state;
  }
}
